export enum AnimalDocumentCategory {
  NOTE_EXPORT = 'note_export',
  FOUND_REPORT = 'found_report',
  SECURING_REPORT = 'securing_report',
  PICKUP_REPORT = 'pickup_report',
  MEDICAL_FINDING = 'medical_finding',
  LAB_REPORT = 'lab_report',
  VACCINATION_CERTIFICATE = 'vaccination_certificate',
  OTHER = 'other',
}

/** Dokumentkategorien, die an einer Karteikarte hängen können. */
export const MEDICAL_DOCUMENT_CATEGORIES: AnimalDocumentCategory[] = [
  AnimalDocumentCategory.MEDICAL_FINDING,
  AnimalDocumentCategory.LAB_REPORT,
  AnimalDocumentCategory.VACCINATION_CERTIFICATE,
  AnimalDocumentCategory.OTHER,
];

export function getAnimalDocumentCategoryEnumKey(value: AnimalDocumentCategory): string | undefined {
  return Object.keys(AnimalDocumentCategory).find((key) => AnimalDocumentCategory[key as keyof typeof AnimalDocumentCategory] === value);
}
